import { library, type IconDefinition, type IconPack } from '@fortawesome/fontawesome-svg-core';

export function useIcons(icons: (IconDefinition | IconPack)[]) {
    library.add(...icons);
}
